import { Link } from "react-router-dom";
import { useSeo } from "@/utils/seo";
import { ArrowUpRight, FileDown } from "lucide-react";
import { SOFTWARE } from "@/data/downloads";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useLang } from "@/i18n";

export default function SoftwarePage() {
    const { t } = useLang();
    useSeo(
        t("Software-Downloads für Kopfstationen | Müller", "Software downloads for headends | Müller"),
        t(
            "Software und Programmeriervorschläge für Kopfstationen und Steckkarten — kostenlose Downloads von Müller Satelliten- und Antennentechnik.",
            "Software and programming suggestions for headends and plug-in cards — free downloads from Müller Satelliten- und Antennentechnik."
        ),
    );
    return (
        <main data-testid="page-software" className="pt-28 sm:pt-32">
            <section className="py-10 sm:py-14">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
                    <p className="font-mono text-[11px] uppercase tracking-widest text-slate-400" data-testid="breadcrumb">
                        <Link to="/downloads" data-testid="breadcrumb-downloads" className="hover:text-red-700 transition-colors">
                            {t("Download", "Downloads")}
                        </Link>
                        <span className="mx-2">/</span>
                        <span className="text-slate-600">{t("Software", "Software")}</span>
                    </p>
                    <Reveal>
                        <Eyebrow>{t("Software", "Software")}</Eyebrow>
                        <h1 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
                            {t("Programmier-Software & Firmware.", "Programming software & firmware.")}
                        </h1>
                        <p className="mt-4 text-slate-600 leading-relaxed max-w-2xl text-sm sm:text-base">
                            {t(
                                "Hier finden Sie die aktuelle Software zur Programmierung unserer Kopfstationen und Einzelumsetzer sowie die STRO-Firmware.",
                                "Here you'll find the latest software for programming our headends and transmodulators, plus the STRO firmware."
                            )}
                        </p>
                    </Reveal>
                </div>
            </section>

            <section className="pb-16 sm:pb-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 space-y-5">
                    {SOFTWARE.map((s, i) => (
                        <Reveal key={s.name} delay={i * 0.08}>
                            <div className="rounded-2xl bg-white border border-slate-200 p-7 sm:p-8 shadow-sm" data-testid={`software-item-${i}`}>
                                <h2 className="font-display text-lg sm:text-xl font-bold text-slate-900">{s.name}</h2>
                                <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                                <a
                                    href={s.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`software-download-${i}`}
                                    className="mt-5 inline-flex items-center gap-2 rounded-full bg-red-700 hover:bg-red-800 text-white text-sm font-semibold px-6 py-3 transition-colors"
                                >
                                    <FileDown className="h-4 w-4" />
                                    {t("Download öffnen", "Open download")}
                                </a>
                            </div>
                        </Reveal>
                    ))}
                    <div>
                        <Link
                            to="/downloads"
                            data-testid="back-to-downloads"
                            className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-red-700 transition-colors"
                        >
                            <ArrowUpRight className="h-4 w-4 rotate-180" />
                            {t("Zurück zu allen Downloads", "Back to all downloads")}
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    );
}
